export class EmailMarketingTagDTO {
    constructor(
        public name: string
    ) { }
}
